import axios from "axios";
import { API_BASE_URL } from "../constants/apiConstants";
import { logout } from "../utils";
import { getDecryptedDataFromSessionStorage } from "../utils";
import { SECRET_KEY } from "../constants/encriptKey";
const API_URL = `${API_BASE_URL}backoffice/Medicos/`;

export async function consultaMedicos(criteria) {
  const url = `${API_URL}ConsultaMedicos`;
  const data = getDecryptedDataFromSessionStorage(SECRET_KEY);
  const { accessToken } = data

  try {
    const response = await axios.post(url, criteria, {
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    
    if (response.data.status === "Ok") {
      return response.data.result ? response.data.result.medicos : [];
    } else if (response.data.status === "Error") {
      logout(); 
      window.location.href = "/backoffice"; 
      return []; 
    }
  } catch (error) {
    return { error: error.message };
  }
}

export async function ActualizaMedicoBO(idMedico) {
  const url = `${API_URL}ActualizaMedicoBO`;

  try {
    const response = await axios.put(url, {
      idMedico,
      nombre: "",
      apellido: "",
      especialidad: "",
      telefono: "",
      email: "",
      direccionConsultorio: "",
      fechaNacimiento: null,
      sexo: "",
      pais: "",
      aprobado: true,
    });

    console.log(`ari ActualizaMedicoBO ${JSON.stringify(response.data)}`)
    return response.data.result;
  } catch (error) {
    return { error: error.message };
  }
}
